import {Component, OnInit} from '@angular/core';
import {AppComponent} from './app.component';
import { SeguridadService } from './services/seguridad.service';
import { GrupoAcceso, GrupoAccesoModulo } from './models/seguridad/grupo_acceso.model';
import { MenuService } from './services/menu.service';

@Component({
    selector: 'app-menu',
    template: `
        <ul class="layout-menu">
            <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
        </ul>
    `
})
export class AppMenuComponent implements OnInit {

    model: any[];
    currentUser: any;
    grupoAcceso: GrupoAcceso;
    routerLinkBase: string = '/pages'
    icon = 'pi pi-fw pi-bookmark-fill';


    constructor(public app: AppComponent, public seguridad: SeguridadService, private menuService: MenuService ) {
        this.currentUser = seguridad.getCurrentUser();
        this.grupoAcceso = new GrupoAcceso();
        this.grupoAcceso.cargarObjeto(this.currentUser.grupo_acceso);
    }

    ngOnInit() {
        // this.model = [
        //     {
        //         label: 'Favorites', icon: 'pi pi-fw pi-home',
        //         items: [
        //             {label: 'Dashboard Sales', icon: 'pi pi-fw pi-home', routerLink: ['/home'], badge: '4', badgeClass: 'p-badge-info'},
        //             {label: 'Dashboard Analytics', icon: 'pi pi-fw pi-home',
        //                 routerLink: ['/favorites/dashboardanalytics'], badge: '2', badgeClass: 'p-badge-success'}
        //         ]
        //     },            
        //     {
        //         label: 'UI Kit', icon: 'pi pi-fw pi-star', routerLink: ['/uikit'],
        //         items: [
        //             {label: 'Form Layout', icon: 'pi pi-fw pi-id-card', routerLink: ['/uikit/formlayout']},
        //             {label: 'Input', icon: 'pi pi-fw pi-check-square', routerLink: ['/uikit/input'], badge: '6', badgeClass: 'p-badge-danger'},
        //             {label: 'Float Label', icon: 'pi pi-fw pi-bookmark', routerLink: ['/uikit/floatlabel']},
        //             {label: 'Invalid State', icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/uikit/invalidstate']},
        //             {label: 'Button', icon: 'pi pi-fw pi-mobile', routerLink: ['/uikit/button'], class: 'rotated-icon'},
        //             {label: 'Table', icon: 'pi pi-fw pi-table', routerLink: ['/uikit/table'], badge: '6', badgeClass: 'p-badge-help'},
        //             {label: 'List', icon: 'pi pi-fw pi-list', routerLink: ['/uikit/list']},
        //             {label: 'Tree', icon: 'pi pi-fw pi-share-alt', routerLink: ['/uikit/tree']},
        //             {label: 'Panel', icon: 'pi pi-fw pi-tablet', routerLink: ['/uikit/panel']},
        //             {label: 'Overlay', icon: 'pi pi-fw pi-clone', routerLink: ['/uikit/overlay']},
        //             {label: 'Media', icon: 'pi pi-fw pi-image', routerLink: ['/uikit/media']},
        //             {label: 'Menu', icon: 'pi pi-fw pi-bars', routerLink: ['/uikit/menu'], preventExact: true},
        //             {label: 'Message', icon: 'pi pi-fw pi-comment', routerLink: ['/uikit/message']},
        //             {label: 'File', icon: 'pi pi-fw pi-file', routerLink: ['/uikit/file']},
        //             {label: 'Chart', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/uikit/charts']},
        //             {label: 'Misc', icon: 'pi pi-fw pi-circle-off', routerLink: ['/uikit/misc']}
        //         ]
        //     },
        //     {
        //         label:'Prime Blocks', icon:'pi pi-fw pi-prime', routerLink: ['/blocks'],
        //         items:[
        //             {label: 'Free Blocks', icon: 'pi pi-fw pi-eye', routerLink: ['/blocks']},
        //             {label: 'All Blocks', icon: 'pi pi-fw pi-globe', url: ['https://www.primefaces.org/primeblocks-ng'], target: '_blank'},
        //         ]
        //     },
        //     {
        //         label: 'Utilities', icon: 'pi pi-fw pi-compass', routerLink: ['/utilities'],
        //         items: [
        //             {label: 'PrimeIcons', icon: 'pi pi-fw pi-prime', routerLink: ['utilities/icons']},
        //             {label: 'PrimeFlex', icon: 'pi pi-fw pi-desktop', url: ['https://www.primefaces.org/primeflex/'], target: '_blank'},
        //         ]
        //     },
        //     {
        //         label: 'Pages', icon: 'pi pi-fw pi-briefcase', routerLink: ['/pages'],
        //         items: [
        //             {label: 'Crud', icon: 'pi pi-fw pi-pencil', routerLink: ['/pages/crud']},
        //             {label: 'Calendar', icon: 'pi pi-fw pi-calendar-plus', routerLink: ['/pages/calendar']},
        //             {label: 'Timeline', icon: 'pi pi-fw pi-calendar', routerLink: ['/pages/timeline']},
        //             {label: 'Wizard', icon: 'pi pi-fw pi-star', routerLink: ['/wizard']},
        //             {
        //                 label: 'Landing', icon: 'pi pi-fw pi-globe', badge: '2', badgeClass: 'p-badge-warning',
        //                 items: [
        //                     {label: 'Static', icon: 'pi pi-fw pi-globe', url: 'assets/pages/landing.html', target: '_blank'},
        //                     {label: 'Component', icon: 'pi pi-fw pi-globe', routerLink: ['/pages/landing']}
        //                 ]
        //             },
        //             {label: 'Login', icon: 'pi pi-fw pi-sign-in', routerLink: ['/login']},
        //             {label: 'Invoice', icon: 'pi pi-fw pi-dollar', routerLink: ['/pages/invoice']},
        //             {label: 'Help', icon: 'pi pi-fw pi-question-circle', routerLink: ['/pages/help']},
        //             {label: 'Error', icon: 'pi pi-fw pi-times-circle', routerLink: ['/error']},
        //             {label: 'Not Found', icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/notfound']},
        //             {label: 'Access Denied', icon: 'pi pi-fw pi-lock', routerLink: ['/access']},
        //             {label: 'Contact Us', icon: 'pi pi-fw pi-pencil', routerLink: ['/contactus']},
        //             {label: 'Empty', icon: 'pi pi-fw pi-circle-off', routerLink: ['/pages/empty']}
        //         ]
        //     },
        //     {
        //         label: 'Hierarchy', icon: 'pi pi-fw pi-align-left',
        //         items: [
        //             {
        //                 label: 'Submenu 1', icon: 'pi pi-fw pi-align-left',
        //                 items: [
        //                     {
        //                         label: 'Submenu 1.1', icon: 'pi pi-fw pi-align-left',
        //                         items: [
        //                             {label: 'Submenu 1.1.1', icon: 'pi pi-fw pi-align-left'},
        //                             {label: 'Submenu 1.1.2', icon: 'pi pi-fw pi-align-left'},
        //                             {label: 'Submenu 1.1.3', icon: 'pi pi-fw pi-align-left'},
        //                         ]
        //                     },
        //                     {
        //                         label: 'Submenu 1.2', icon: 'pi pi-fw pi-align-left',
        //                         items: [
        //                             {label: 'Submenu 1.2.1', icon: 'pi pi-fw pi-align-left'}
        //                         ]
        //                     },
        //                 ]
        //             },
        //             {
        //                 label: 'Submenu 2', icon: 'pi pi-fw pi-align-left',
        //                 items: [
        //                     {
        //                         label: 'Submenu 2.1', icon: 'pi pi-fw pi-align-left',
        //                         items: [
        //                             {label: 'Submenu 2.1.1', icon: 'pi pi-fw pi-align-left'},
        //                             {label: 'Submenu 2.1.2', icon: 'pi pi-fw pi-align-left'},
        //                         ]
        //                     },
        //                     {
        //                         label: 'Submenu 2.2', icon: 'pi pi-fw pi-align-left',
        //                         items: [
        //                             {label: 'Submenu 2.2.1', icon: 'pi pi-fw pi-align-left'},
        //                         ]
        //                     },
        //                 ]
        //             }
        //         ]
        //     },
        //     {
        //         label: 'Start', icon: 'pi pi-fw pi-download',
        //         items: [
        //             {
        //                 label: 'Buy Now', icon: 'pi pi-fw pi-shopping-cart', url: ['https://www.primefaces.org/store']
        //             },
        //             {
        //                 label: 'Documentation', icon: 'pi pi-fw pi-info-circle', routerLink: ['/documentation']
        //             }
        //         ]
        //     }
        // ];
        this.getMenu();
    }

    async getMenu() {
        this.model = await this.menuService.getMenu();
        // const menuRouterLink = `${ this.routerLinkBase }/home`;
        // const menu = [
        //     { 
        //         label: 'Home', icon: 'pi pi-fw pi-home', routerLink: [menuRouterLink],
        //         items: [
        //             {label: 'Dashboard 1', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/dashboard1`] },
                    // {label: 'Dashboard 2', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/dashboard2`] },
        //         ]
        //     },
        // ];
        
        // if ( this.grupoAcceso.accesoTotal ) {
        //     menu.push( await this.getMenuConfiguracion( this.grupoAcceso.accesoTotal ) );
        //     menu.push( await this.getMenuExtracto( this.grupoAcceso.accesoTotal ) );
        //     menu.push( await this.getMenuContabilidad( this.grupoAcceso.accesoTotal ));
        //     menu.push( await this.getMenuTesoreria( this.grupoAcceso.accesoTotal ));
        //     menu.push( await this.getMenuSeguridad( this.grupoAcceso.accesoTotal ) );
        //     menu.push( await this.getMenuPagofacil( this.grupoAcceso.accesoTotal ) );
        //     menu.push( await this.getMenuClienteTarjeta( this.grupoAcceso.accesoTotal ) );
        // } else {
        //     // modulos activos
        //     for (const modulo of this.grupoAcceso.modulos) {
        //         const mod = new GrupoAccesoModulo();
        //         mod.cargarObjeto(modulo);
        //         if ( mod.activo ) {
        //             switch (mod.codigo) {
        //                 case 'configuracion':
        //                     menu.push( await this.getMenuConfiguracion(mod.accesoTotal) );
        //                     break;
        //                 case 'extracto':
        //                     menu.push( await this.getMenuExtracto(mod.accesoTotal) );
        //                     break;
        //                 case 'seguridad':
        //                     menu.push( await this.getMenuSeguridad(mod.accesoTotal) );
        //                     break;
        //                 case 'contabilidad':
        //                     menu.push( await this.getMenuContabilidad(mod.accesoTotal) );
        //                     break;
        //                 case 'tesoreria':
        //                     menu.push( await this.getMenuTesoreria(mod.accesoTotal) );
        //                     break;
        //                 case 'pagofacil':                            
        //                     menu.push( await this.getMenuPagofacil(mod.accesoTotal) );
        //                     break;
        //                 case 'cliente-tarjeta':                            
        //                     menu.push( await this.getMenuClienteTarjeta(mod.accesoTotal) );
        //                     break;
        //                 default:
    //                         break;
    //                 }
    //             }
    //         }
    //     }
    //     this.model = menu;
    // }

    // async getMenuConfiguracion( accesoTotal: boolean ) {
    //     const menuRouterLink = `${ this.routerLinkBase }/configuracion`;
    //     const menu = {
    //         label: 'Configuración', icon: 'pi pi-fw pi-cog', routerLink: [menuRouterLink],
    //         items: []
    //     }
    //     if ( accesoTotal ) {
    //         menu.items = [
    //             {label: 'Empresas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/empresas`]},
    //             {label: 'Sucursales', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/sucursales`]},
    //             {label: 'Grupos de Clientes', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/grupos-clientes`]},
    //             {label: 'Punto de Expedición', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/puntos-expedicion`]},
                // {label: 'Bancos', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/bancos`]},
                // {label: 'Departamentos', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/departamentos`]},
                // {label: 'Ciudades', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/ciudades`]},
                // {label: 'Barrios', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/barrios`]},
            // ]
    //     } else {
    //         for (const registro of this.grupoAcceso.registros.filter( reg => reg.modulo === 'configuracion') ) {
    //             switch (registro.codigo) {
    //                 case 'empresa':
    //                     if ( registro.ver ) {
    //                         menu.items.push( {label: 'Empresas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/empresas`]} )
    //                     }
    //                 break;
    //                 case 'sucursal':
    //                     if ( registro.ver ) {
    //                         menu.items.push( {label: 'Sucursales', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/sucursales`]} )
    //                     }
    //                 break;
    //                 case 'grupo_cliente':
    //                     if ( registro.ver ) {
    //                         menu.items.push( {label: 'Grupos de Clientes', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/grupos-clientes`]} )
    //                     }
    //                 break;
    //                 case 'punto_expedicion':
    //                     if ( registro.ver ) {
    //                         menu.items.push( {label: 'Puntos de Expedición', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/puntos-expedicion`]} )
    //                     }
    //                 break;
    //                 case 'banco':
    //                     if ( registro.ver ) {
    //                         menu.items.push( {label: 'Bancos', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/bancos`]} )
    //                     }
    //                 break;
    //                 case 'departamento':
    //                     if ( registro.ver ) {
    //                         menu.items.push( {label: 'Departamentos', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/departamentos`]} )
    //                     }
    //                 break;
    //                 case 'ciudad':
    //                     if ( registro.ver ) {
    //                         menu.items.push( {label: 'Ciudades', icon: 'pi pi-fw pi-bookmark', routerLink: ['/configuracion/ciudades']} )
    //                     }
    //                 break;
    //                 case 'barrio':
    //                     if ( registro.ver ) {
    //                         menu.items.push( {label: 'Barrios', icon: 'pi pi-fw pi-bookmark', routerLink: ['/configuracion/barrios']} )
    //                     }
    //                 break;
    //                 default:
    //                     break;
    //             }
    //         }            
    //     }
    //     return menu;
    // }

    // async getMenuExtracto( accesoTotal: boolean ) {
    //     const menuRouterLink = `${ this.routerLinkBase }/extracto`;
    //     const menu = {
    //         label: 'Extracto', icon: 'pi pi-fw pi-desktop', routerLink: [menuRouterLink],
    //         items: []
    //     }
    //     if ( accesoTotal ) {
    //         menu.items = [
    //             {label: 'Tarjetas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/tarjetas`]},
    //             {label: 'Enviar Extracto', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/enviar`]},
    //         ]
    //     } else {
    //         for (const registro of this.grupoAcceso.registros.filter( reg => reg.modulo === 'extracto' ) ) {
    //             switch (registro.codigo) {
    //                 case 'tarjeta':
    //                     if ( registro.ver ) {
    //                         menu.items.push( {label: 'Tarjetas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/tarjetas`]} )
    //                     }
    //                 break;
    //                 default:
    //                     break;
    //             }
    //         }
    //         for (const permiso of this.grupoAcceso.permisos.filter( reg => reg.codigo === 'enviar_extracto') ) {
    //             if ( permiso.activo ) {
    //                 menu.items.push( {label: 'Enviar Extracto', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/enviar`]} )
    //             }
    //         }
    //     }
    //     return menu;
    // }

    // async getMenuSeguridad( accesoTotal: boolean ) {
    //     const menuRouterLink = `${ this.routerLinkBase }/seguridad`;
    //     const menu = {
    //         label: 'Seguridad', icon: 'pi pi-fw pi-desktop', routerLink: [menuRouterLink],
    //         items: []
    //     }
    //     if ( accesoTotal ) {
    //         menu.items = [
    //             {label: 'Usuarios', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/usuarios`]},
    //             {label: 'Grupos de Acceso', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/grupos-acceso`]},
    //         ];
    //     } else {
    //         for (const registro of this.grupoAcceso.registros.filter( reg => reg.modulo === 'seguridad') ) { 
    //             switch (registro.codigo) {
    //                 case 'usuario':
    //                     if ( registro.ver ) {
    //                         menu.items.push( {label: 'Usuarios', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/usuarios`]} )
    //                     }
    //                 break;
    //                 case 'grupo_acceso':
    //                     if ( registro.ver ) {
    //                         menu.items.push( {label: 'Grupos de Acceso', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/grupos-acceso`]} )
    //                     }
    //                 break;
    //                 default:
    //                     break;
    //             }
    //         }
    //     }

    //     return menu;
    // }

    // async getMenuContabilidad( accesoTotal: boolean ) {
    //     const menuRouterLink = `${ this.routerLinkBase }/contabilidad`;
    //     const menu = {
    //         label: 'Contabilidad', icon: 'pi pi-fw pi-book', routerLink: [menuRouterLink],
    //         items: []
    //     }
    //     if ( accesoTotal ) {
    //         menu.items = [
    //             {label: 'Cuentas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/cuentas`]},
    //             {label: 'Asientos', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/asientos`]},
    //         ]
    //     } else {
    //         for (const registro of this.grupoAcceso.registros.filter( reg => reg.modulo === 'contabilidad') ) { 
    //             switch (registro.codigo) {
    //                 case 'cuenta':
    //                     if ( registro.ver ) {
    //                         menu.items.push( {label: 'Cuentas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/cuentas`]} )
    //                     }
    //                 break;
    //                 case 'asiento':
    //                     if ( registro.ver ) {
    //                         menu.items.push( {label: 'Asientos', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/asientos`]} )
    //                     }
    //                 break;
    //                 default:
    //                     break;
    //             }
    //         }
    //     }

    //     return menu;
    // }

    // async getMenuTesoreria( accesoTotal: boolean ) {
    //     const menuRouterLink = `${ this.routerLinkBase }/tesoreria`;
    //     const menu = {
    //         label: 'Tesoreria', icon: 'pi pi-fw pi-money-bill', routerLink: [menuRouterLink],
    //         items: []
    //     }
    //     if ( accesoTotal ) {
    //         menu.items = [
    //             {label: 'Conceptos', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/conceptos`]},
    //             {label: 'Cajas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/cajas`]},
    //             {label: 'Aperturas/Cierres de Caja', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/eventos`]},
    //             {label: 'Rendiciones', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/rendiciones`]},
    //             {label: 'Rendiciones de Caja', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/rendiciones-caja`]}
    //         ]
            // menu.items.push(
            //     {
            //         label: 'Reportes', icon: 'pi pi-fw pi-book',
            //         items: [
            //             { label: 'Rendiciones de Caja', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/reportes/listado-rendicion-caja`] }
            //         ]
            //     }
            // )
        // } else {
        //     for (const registro of this.grupoAcceso.registros.filter( reg => reg.modulo === 'tesoreria') ) { 
        //         switch (registro.codigo) {
        //             case 'concepto':
        //                 if ( registro.ver ) {
        //                     menu.items.push( {label: 'Conceptos', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/conceptos`]} )
        //                 }
        //             break;
        //             case 'caja':
        //                 if ( registro.ver ) {
        //                     menu.items.push( {label: 'Cajas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/cajas`]} )
        //                 }
        //             break;
        //             case 'evento_caja':
        //                 if ( registro.ver ) {
        //                     menu.items.push( {label: 'Aperturas/Cierres de Caja', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/eventos`]} )
        //                 }
        //             break;
        //             case 'rendicion':
        //                 if ( registro.ver ) {
        //                     menu.items.push( {label: 'Rendiciones', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/rendiciones`]} )
        //                 }
        //             break;
        //             case 'rendicion_caja':
        //                 if ( registro.ver ) {
        //                     menu.items.push( {label: 'Rendiciones de Caja', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/rendiciones-caja`]} )
        //                 }
        //             break;
        //             default:
        //                 break;
        //         }
        //     }
            // const reportes = [];
            // for (const reporte of this.grupoAcceso.reportes.filter( rep => rep.modulo === 'tesoreria' )) {
            //     switch (reporte.codigo) {
            //         case 'listado_rendicion_caja':
            //             if ( reporte.activo ) {
            //                 reportes.push( { label: 'Rendiciones de Caja', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/reportes/listado-rendicion-caja`] } )
            //             }
            //     }
            // }
            // if ( reportes.length > 0 ) {
            //     menu.items.push(
            //         {
            //             label: 'Reportes', icon: 'pi pi-fw pi-book',
            //             items: reportes
            //         }
            //     );
            // }
        }

    //     return menu;
    // }

    // async getMenuClienteTarjeta( accesoTotal: boolean ) {
    //     const menuRouterLink = `${ this.routerLinkBase }/tarjeta`;
    //     const menu = {
    //         label: 'Cliente Tarjeta', icon: 'pi pi-fw pi-credit-card', routerLink: [menuRouterLink],
    //         items: []
    //     }
    //     if ( accesoTotal ) {
    //         menu.items.push(...[
    //             {label: 'Grupos de Tarjetas', icon: this.icon, routerLink: [`${menuRouterLink}/grupo-tarjetas`]},
    //         ]);
    //     } else {
    //         for (const registro of this.grupoAcceso.registros.filter( reg => reg.modulo === 'cliente-tarjeta') ) { 
    //             switch (registro.codigo) {
    //                 case 'grupo_tarjeta':
    //                     if ( registro.ver ) {
    //                         menu.items.push( {label: 'Grupos de Tarjetas', icon: this.icon, routerLink: [`${menuRouterLink}/grupo-tarjetas`]} )
    //                     }
    //                 break;
    //                 default:
    //                     break;
    //             }
    //         }
    //     }

    //     return menu;
    // }
    // async getMenuPagofacil( accesoTotal: boolean ) {           
    //     const menuRouterLink = `${ this.routerLinkBase }/pagofacil`;
    //     const menu = {
    //         label: 'Pago Fácil', icon: 'pi pi-fw pi-money-bill', routerLink: [menuRouterLink],
    //         items: []
    //     }
    //     if ( accesoTotal ) {
    //         menu.items = [
    //             {label: 'Grupo de Tarjetas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/grupo-tarjetas`]},
    //             {label: 'Tarjetas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/tarjetas`]},
                // {label: 'Pago de Tarjetas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/pago-tarjetas`]},
        //         {label: 'Prestamo Solidario', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/prestamo-solidario`]},
        //         {label: 'Pagares', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/pagares`]}
        //     ]
        //     menu.items.push(
        //         {
        //             label: 'Reportes', icon: 'pi pi-fw pi-book',
        //             items: [
        //                 { label: 'Prestamos Solidarios', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/reportes/listado-prestamo-solidario`] },
        //                 { label: 'Procesar Tarjetas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/reportes/procesar-tarjeta`] }
        //             ]
        //         }
        //     )
        //     menu.items.push(
        //         {
        //             label: 'Procesos', icon: 'pi pi-fw pi-sync',
        //             items: [
        //                 { label: 'Actualizar Saldo Tarjeta', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/procesos/actualizar-saldo`] },
        //                 { label: 'Actualizar Saldo Grupo', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/procesos/actualizar-saldo-grupo`] }
        //             ]
        //         }
        //     )
        // } else {
        //     for (const registro of this.grupoAcceso.registros.filter( reg => reg.modulo === 'pagofacil' ) ) { 
        //         switch (registro.codigo) {
        //             case 'pf_tarjeta':
        //                 if ( registro.ver ) {
        //                     menu.items.push( {label: 'Tarjetas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/tarjetas`]} )
        //                 }
        //             break;
        //             case 'pf_grupo_tarjeta':
        //                 if ( registro.ver ) {
        //                     menu.items.push( {label: 'Grupo de Tarjetas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/grupo-tarjetas`]} )
        //                 }
        //             break;
                    // case 'pf_pago_tarjeta':
                    //     if ( registro.ver ) {
                    //         menu.items.push( {label: 'Pago de Tarjetas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/pago-tarjetas`]} )
                    //     }
                    // break;
            //         case 'pf_pago_grupo_tarjeta':
            //             if ( registro.ver ) {
            //                 menu.items.push( {label: 'Prestamo Solidario', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/prestamo-solidario`]} )
            //             }
            //         break;
            //         case 'pf_pagare':
            //             if ( registro.ver ) {
            //                 menu.items.push( {label: 'Pagares', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/pagares`]} )
            //             }
            //         break;
            //         default:
            //             break;
            //     }
            // }

            // const reportes = [];
            // for (const reporte of this.grupoAcceso.reportes.filter( rep => rep.modulo === 'pagofacil' )) {
            //     switch (reporte.codigo) {
            //         case 'listado_pago_grupo_tarjeta':
            //             if ( reporte.activo ) {
            //                 reportes.push( { label: 'Prestamo Solidario', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/reportes/listado-prestamo-solidario`] } )
            //             }
            //         break;
            //         case 'procesar_tarjeta':
            //             if ( reporte.activo ) {
            //                 reportes.push( { label: 'Procesar Tarjetas', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/reportes/procesar-tarjeta`] }
            //                 )
            //             }
            //         break;
            //     }
            // }

            // const procesos = [];
            // console.log(this.grupoAcceso.permisos);
            
    //         for (const permiso of this.grupoAcceso.permisos.filter( reg => reg.codigo === 'actualizar_saldo') ) {
    //             if ( permiso.activo ) {
    //                 procesos.push( {label: 'Actualizar Saldo', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/procesos/actualizar-saldo`]} )
    //             }
    //         }
    //         for (const permiso of this.grupoAcceso.permisos.filter( reg => reg.codigo === 'actualizar_saldo_grupo') ) {
    //             if ( permiso.activo ) {
    //                 procesos.push( {label: 'Actualizar Saldo Grupo', icon: 'pi pi-fw pi-bookmark', routerLink: [`${menuRouterLink}/procesos/actualizar-saldo-grupo`]} )
    //             }
    //         }

    //         if ( reportes.length > 0 ) {
    //             menu.items.push(
    //                 {
    //                     label: 'Reportes', icon: 'pi pi-fw pi-book',
    //                     items: reportes
    //                 }
    //             );
    //         }

    //         if ( [procesos].length > 0 ) {
    //             menu.items.push(
    //                 {
    //                     label: 'Procesos', icon: 'pi pi-fw pi-sync',
    //                     items: procesos
    //                 }
    //             );
    //         }
    //     }

    //     return menu;
    // }

    
}
